// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-left: 200px;
  padding-right: 200px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.btn {
  width: 228px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #AF2C30;
  border-radius: 10px;
  text-transform: uppercase;
  color: #FFFFFF;
  font-weight: 400;
  font-size: 15px;
  border: none;
  letter-spacing: -0.05em;
}
.underline{
  text-decoration: underline;
}

@media(max-width:991px) {
  .container {
      padding-left: 50px;
      padding-right: 50px;
  }
}

@media(max-width: 750px) {
  .container {
      padding-left: 15px;
      padding-right: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;MACI,kBAAkB;MAClB,mBAAmB;EACvB;AACF;;AAEA;EACE;MACI,kBAAkB;MAClB,mBAAmB;EACvB;AACF","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding-left: 200px;\n  padding-right: 200px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.btn {\n  width: 228px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background-color: #AF2C30;\n  border-radius: 10px;\n  text-transform: uppercase;\n  color: #FFFFFF;\n  font-weight: 400;\n  font-size: 15px;\n  border: none;\n  letter-spacing: -0.05em;\n}\n.underline{\n  text-decoration: underline;\n}\n\n@media(max-width:991px) {\n  .container {\n      padding-left: 50px;\n      padding-right: 50px;\n  }\n}\n\n@media(max-width: 750px) {\n  .container {\n      padding-left: 15px;\n      padding-right: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
